import { useEffect, useState } from "react";
import CustomModal from "../CustomModal/CustomModal";
import Select from "../Select/Select";
import Button from "../Button/Button";
import { ROLES } from "../../../utils/Common/Constant";
import "./RoleSelectModal.scss";

interface RoleSelectModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: (role: string) => void;
  loading?: boolean;
  title?: string;
  description?: string;
  confirmLabel?: string;
}

const ROLE_OPTIONS = [
  { value: ROLES.ADMIN, label: "Admin" },
  { value: ROLES.GC, label: "General Contractor" },
  { value: ROLES.LENDER, label: "Lender / Bank" },
  { value: ROLES.OWNER, label: "Owner / Borrower" },
  { value: ROLES.INSPECTOR, label: "Inspector" },
];

const SELECT_CONTROL_STYLE = {
  border: "1px solid #d8dee8",
  borderRadius: "14px",
  backgroundColor: "#f8fafc",
};

const RoleSelectModal = ({
  show,
  onClose,
  onConfirm,
  loading = false,
  title = "Select your role",
  description = "Choose the role you want to sign in as to continue.",
  confirmLabel = "Continue",
}: RoleSelectModalProps) => {
  const [role, setRole] = useState("");

  useEffect(() => {
    if (!show) setRole("");
  }, [show]);

  return (
    <>
      <div
        className={`rsmBackdrop ${show ? "rsmBackdrop--show" : ""}`}
        aria-hidden="true"
      />
      <CustomModal
        show={show}
        handleClose={onClose}
        title={title}
        className="roleSelectModalDialog"
        backdrop={false}
        footerContent={
          <>
            <Button
              type="button"
              className="rsmBtn rsmBtnGhost"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="button"
              className="rsmBtn rsmBtnPrimary"
              onClick={() => onConfirm(role)}
              disabled={!role || loading}
            >
              {loading ? "Please wait…" : confirmLabel}
            </Button>
          </>
        }
      >
        {description && <p className="rsmDesc">{description}</p>}
        <div className="field">
          <label htmlFor="role-select">Role</label>
          <Select
            id="role-select"
            options={ROLE_OPTIONS}
            value={role}
            placeholder="Choose a role"
            onChange={(e) => setRole(e.target.value)}
            height="46px"
            style={SELECT_CONTROL_STYLE}
            menuPortal
          />
        </div>
      </CustomModal>
    </>
  );
};

export default RoleSelectModal;
